import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import Logo from './Logo';

export default function Header({
  isExtended = false,
  className = '',
  logoClassName = '',
  children = null
}) {
  return (
    <header className={cn(styles.container, className)}>
      <UiKit.MaxWidthContainer isExtended={isExtended}>
        <UiKit.Grid
          templateColumns="216px 1fr"
          gap="24"
          className={styles.grid}
        >
          <Logo className={logoClassName} />
          <div className={styles.content}>{children}</div>
        </UiKit.Grid>
      </UiKit.MaxWidthContainer>
    </header>
  );
}
